import { useState, useEffect } from "react";

export const Page = () => {

  const server = {
    url: "https://api.liontravelers.com/api",
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + process.env.REACT_APP_BEARER_TOKEN
    }
  };
  const [identifier, setIdentifier] = useState({
    nft: "lion-travelers-nft",
    whitelist: "lion-travelers-nft"
  });

  const api = {
    nft: {
      edition: {
        create: {
          url: `${server.url}/nft/${identifier.nft}/edition/create`,
          params: {
            nft: identifier.nft,
            number: null,
            supply: null,
            mint_price: null,
            royalty: null,
            whitelist_supply: null,
            whitelist_price: null,
            cid: null,
          },
        },
        search: {
          url: `${server.url}/nft/${identifier.nft}/edition/search`,
          params: {
            nft: identifier.nft,
            search: null,
            order: null,
            start: null,
            length: null,
            draw: null,
            model: null,
          },
        },
        count: {
          url: `${server.url}/nft/${identifier.nft}/edition/count`,
          params: { nft: identifier.nft },
        },
        info: {
          url: `${server.url}/nft/${identifier.nft}/edition/{number}/info`,
          params: { nft: identifier.nft, number: null },
        },
        update: {
          url: `${server.url}/nft/${identifier.nft}/edition/{number}/update`,
          params: { nft: identifier.nft, number: null },
        },
        delete: {
          url: `${server.url}/nft/${identifier.nft}/edition/{number}/delete`,
          params: { nft: identifier.nft, number: null },
        },
      },
      collection: {
        info: {
          url: `${server.url}/nft/${identifier.nft}/info`,
          params: { nft: identifier.nft, dna: null },
        },
        search: {
          url: `${server.url}/nft/${identifier.nft}/collection/search`,
          params: {
            nft: identifier.nft,
            edition: null,
            search: null,
            order: null,
            start: null,
            length: null,
            draw: null,
            model: null,
          },
        },
        count: {
          url: `${server.url}/nft/${identifier.nft}/collection/count`,
          params: { nft: identifier.nft },
        },
        update: {
          url: `${server.url}/nft/${identifier.nft}/collection/{number}/update`,
          params: { nft: identifier.nft, number: null },
        },
        mint: {
          url: `${server.url}/nft/${identifier.nft}/collection/mint`,
          params: {
            edition: null,
            ipfs_id: null,
            txn_hash: null,
            wallet_address: null,
            amount: null,
            currency: null,
            usd: null,
            apr: null,
            keypass: null,
          },
        },
      },
      create: {
        url: `${server.url}/nft/create`,
        params: {
          name: null,
          description: null,
          website: null,
          supply: null,
          mint_price: null,
          royalty: null,
          whitelist_supply: null,
          whitelist_price: null,
          cid: null,
          network: process.env.REACT_APP_NETWORK,
          smart_contract_address: null,
        },
      },
      search: {
        url: `${server.url}/nft/search`,
        params: {
          search: null,
          order: null,
          start: null,
          length: null,
          draw: null,
          model: null,
        },
      },
      info: {
        url: `${server.url}/nft/${identifier.nft}/info`,
        params: { identifier: identifier.nft },
      },
      update: {
        url: `${server.url}/nft/${identifier.nft}/update`,
        params: { identifier: identifier.nft },
      },
      delete: {
        url: `${server.url}/nft/${identifier.nft}/delete`,
        params: { identifier: identifier.nft },
      },
    },
    whitelist: {
      wallet: {
        create: {
          url: `${server.url}/whitelist/${identifier.whitelist}/wallet/subscribe`,
          params: {
            whitelist: identifier.whitelist,
            network: process.env.REACT_APP_NETWORK,
            address: null,
            nfts_address: null,
            nft_count: null,
            eth: null,
            referral: null,
            email: null,
          },
        },
        search: {
          url: `${server.url}/whitelist/${identifier.whitelist}/wallet/search`,
          params: {
            whitelist: identifier.whitelist,
            search: null,
            order: null,
            start: null,
            length: null,
            draw: null,
            model: null,
          },
        },
        count: {
          url: `${server.url}/whitelist/${identifier.whitelist}/wallet/count`,
          params: { whitelist: identifier.whitelist },
        },
        info: {
          url: `${server.url}/whitelist/${identifier.whitelist}/wallet/{address}/info`,
          params: { whitelist: identifier.whitelist, address: null },
        },
        update: {
          url: `${server.url}/whitelist/${identifier.whitelist}/wallet/{address}/update`,
          params: { whitelist: identifier.whitelist, address: null },
        },
        delete: {
          url: `${server.url}/whitelist/${identifier.whitelist}/wallet/{address}/delete`,
          params: { whitelist: identifier.whitelist, address: null },
        },
        mint: {
          url: `${server.url}/whitelist/${identifier.whitelist}/wallet/mint`,
          params: { whitelist: identifier.whitelist, address: null },
        },
      },
      create: {
        url: `${server.url}/whitelist/create`,
        params: {
          name: null,
          description: null,
          website: null,
          collabs: null,
          spots: null,
          required_discord: null,
          required_instagram: null,
          required_twitter: null,
          required_nft_count: null,
          required_nft: null,
          required_eth: null,
          note: null,
        },
      },
      search: {
        url: `${server.url}/whitelist/search`,
        params: {
          search: null,
          order: null,
          start: null,
          length: null,
          draw: null,
          model: null,
        },
      },
      info: {
        url: `${server.url}/whitelist/${identifier.whitelist}/info`,
        params: { identifier: identifier.whitelist },
      },
      update: {
        url: `${server.url}/whitelist/${identifier.whitelist}/update`,
        params: { identifier: identifier.whitelist },
      },
      delete: {
        url: `${server.url}/whitelist/${identifier.whitelist}/delete`,
        params: { identifier: identifier.whitelist },
      },
      status: {
        url: `${server.url}/whitelist/${identifier.whitelist}/status`,
        params: { status: null, start_at: null },
      },
    },
  };
  const columns = {
    nft: {
      edition: {
        id: {
          name: "#",
          sortable: false,
          callback: ({ index }) => {
            return index + 1;
          },
        },
        mint_price: {
          name: "Mint Price",
          sortable: false,
          callback: null,
        },
        supply: {
          name: "Supply",
          sortable: false,
          callback: null,
        },
        whitelist_supply: {
          name: "Whitelist",
          sortable: false,
          callback: null,
        },
        minted: {
          name: "Minted",
          sortable: false,
          callback: null,
        },
        actions: {
          sortable: false,
          callback: ({ data, makeRequest }) => {
            return (
              <button
                className="btn btn-sm btn-outline-danger border-0"
                title="remove"
              >
                <i className="fa fa-trash" />
              </button>
            );
          },
        },
      },
      collection: {
        date: {
          name: "Mint Date",
          sortable: false,
          callback: ({ data }) => {
            const date = new Date(data.date);

            return (
              <>
                {date.toDateString()}
                <br />
                {date.toLocaleTimeString()}
              </>
            );
          },
        },
        nft: {
          name: "NFT",
          sortable: false,
          callback: ({ index }) => {
            return index + 1;
          },
        },
        price: {
          name: "Mint Price",
          sortable: true,
          callback: ({ data }) => {
            return (data.mint && data.mint.amount ?
              `${data.mint.amount} ${data.mint.currency}` :
              "N/A"
            );
          },
        },
        edition: {
          name: "Edition",
          sortable: false,
          callback: ({ data }) => {
            return data.edition;
          },
        },
        rarity: {
          name: "Rarity",
          sortable: false,
          callback: ({ data }) => {
            return (
              <div className="badge fs-12px text-gray-300">{data.rarity}</div>
            );
          },
        },
      },
    },
    whitelist: {
      wallet: {
        id: {
          name: "#",
          sortable: false,
          callback: ({ index }) => {
            return index + 1;
          },
        },
        address: {
          name: "Wallet Address",
          sortable: false,
          callback: null,
        },
        eth: {
          name: "Balance",
          sortable: false,
          callback: null,
        },
        nft_count: {
          name: "NFT",
          sortable: false,
          callback: null,
        },
        minted: {
          name: "Minted",
          sortable: false,
          callback: function (data) {
            return data.data.minted ? <i className="fa fa-check text-primary" /> : null;
          },
        },
        actions: {
          callback: ({ data, makeRequest }) => {
            return (
              <button
                className="btn btn-sm btn-outline-danger border-0"
                title="remove"
              >
                <i className="fa fa-trash" />
              </button>
            );
          },
        },
      },
    },
  };

  const networks_service = {
    Goerli: {
      opensea: "https://testnets.opensea.io/assets/goerli/",
      rarible: "https://testnet.rarible.com/token/",
      ethscan: "https://goerli.etherscan.io/address/",
      basetokenuri: "https://bafybeigahaox7irlu5qzb42ckzfb33vum446ol6cpcb335iiilzzq26oza.ipfs.nftstorage.link/",
    },
    Mainnet: {
      opensea: "https://opensea.io/assets/",
      rarible: "https://rarible.com/token/",
      ethscan: "https://etherscan.io/address/",
      basetokenuri: "https://bafybeigahaox7irlu5qzb42ckzfb33vum446ol6cpcb335iiilzzq26oza.ipfs.nftstorage.link/",
    }
  }

  const [page, setPage] = useState({
    info: {},
    api: api,
    headers: server.headers,
    columns: columns,
    contract_address: process.env.REACT_APP_LIONTRAVELERS_CONTRACT_ADDRESS,
    network: process.env.REACT_APP_NETWORK,
    services: networks_service[process.env.REACT_APP_NETWORK],
  });
  // calling fetchData function for first time
  useEffect(() => {
    //fetching user data from server
    const fetchPage = () => {
      fetch(api.nft.info.url, {
        method: 'GET',
        headers: server.headers,
      })
          .then(res => res.json())
          .then(resp => {
            setPage({...page, ...{
              info: resp.data,
              contract_address: resp.data.smart_contract_address,
              network: resp.data.network,
              cid: resp.data.base_token_uri,
            }})
            setIdentifier({
              nft: resp.data.identifier,
              whitelist: resp.data.identifier
            })
          })
    }
    fetchPage()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return page;
};
